<template>
  <component
    :is="props.clickable ? RevButtonCard : RevCard"
    class="mb-24 flex min-h-[72px] w-full flex-row items-center gap-12 px-16 py-12"
    :class="{
      '!bg-static-info-mid': variant !== 'secondary',
      '!bg-static-default-mid': !clickable && variant === 'secondary',
    }"
    @click="handleClick"
  >
    <DynamicIcon
      v-if="typeof icon === 'string'"
      aria-hidden="true"
      class="m-4 ml-0"
      :icon
      :size="32"
    />
    <component
      :is="icon"
      v-else-if="icon"
      alt=""
      aria-hidden="true"
      class="m-4"
      :size="32"
    />
    <RevIllustration
      v-else-if="image"
      alt=""
      aria-hidden="true"
      class="m-4"
      :height="32"
      :src="image"
      :width="32"
    />

    <div class="body-2 flex-1 text-left">
      <h3 v-if="title" class="text-static-default-hi body-2-bold block">
        {{ title }}
      </h3>
      <p class="mb-0">
        {{ label }}
      </p>
    </div>
    <IconChevronRight v-if="clickable" />
  </component>
</template>

<script lang="ts" setup>
import type { Component } from 'vue'

import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButtonCard } from '@ds/components/ButtonCard'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'
import { openModal } from '@ds/components/ModalBase'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import DynamicIcon from '../DynamicIcon/DynamicIcon.vue'

const props = defineProps<{
  modalName?: string
  icon?: string | Component
  image?: string
  label: string
  title?: string
  /**
   * Secondary variant makes the background grey.
   */
  variant?: 'primary' | 'secondary'
  clickable?: boolean
  tracking?: { zone: string; name: string }
  customOpenModalTrigger?: () => void
}>()

const track = useTracking()

function handleClick(event: MouseEvent) {
  if (props.clickable) {
    if (props.customOpenModalTrigger) {
      props.customOpenModalTrigger()
    } else if (props.modalName) {
      openModal(props.modalName, event)
    }
  }

  if (props.tracking)
    track.trackClick({
      name: props.tracking.name,
      zone: props.tracking.zone,
    })
}
</script>
